import { t } from "i18next"
import { GenderDDL } from "../../../Components/CommonDDL/GenderDDL"
import '../../../theme/amchi-theme.css'

export const GrievanceDetails = (props) => {

    const {
        Language,
        GrievanceField,
        onChange,
        GrievanceTypeID,
        setGrievanceTypeID,
        UserID
    } = props

    return (
        <section className="am-card am-form-card am-rise am-rise-4">
            <div className="am-form-head">
                <span className="am-form-head-ico"><i className="fa-solid fa-file-pen"></i></span>
                <div>
                    <h2>{t('GrievanceRegistration.GrievanceDetails')}</h2>
                    <p>तक्रारीचा प्रकार निवडा व सविस्तर तपशील लिहा</p>
                </div>
            </div>

            <div className="am-form-body">
                <div className="am-form-grid am-form-grid--2">

                    <div className="am-form-item">
                        <label className="am-label">
                            {t('GrievanceRegistration.Grievance')} <span className="am-req">*</span>
                        </label>
                        <div className="am-field am-field--select">
                            <i className="fa-solid fa-tags"></i>
                            <GenderDDL
                                GenderDDLID={GrievanceTypeID}
                                setGenderDDLID={setGrievanceTypeID}
                                Language={Language}
                                GroupID='3'
                                UserID={UserID}
                            />
                        </div>
                    </div>

                    <div className="am-form-item">
                        <label className="am-label">
                            {t('GrievanceRegistration.GrievanceDetails')} <span className="am-req">*</span>
                        </label>
                        <div className="am-field am-field--ta">
                            <i className="fa-solid fa-comment-dots"></i>
                            <textarea
                                placeholder={t('GrievanceRegistration.GrievanceDetails')}
                                name='GrievanceDetails'
                                value={GrievanceField.GrievanceDetails}
                                onChange={onChange}
                            ></textarea>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    )
}
